import { rgba } from 'polished';
import styled from 'styled-components';

import { ProgressBarVariants } from './types';

export const Container = styled.span<{ $variant: ProgressBarVariants }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  width: 100%;

  color: ${({ theme, $variant }) =>
    $variant === ProgressBarVariants.Inverse
      ? theme.palette.info.main
      : theme.palette.text.secondary};
`;

export const Bar = styled.span<{
  $percentage: number;
  $variant: ProgressBarVariants;
}>`
  position: relative;
  flex: 1;
  display: inline-block;
  height: 0.8rem;

  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme, $variant }) =>
    $variant === ProgressBarVariants.Inverse
      ? rgba(theme.palette.common.white, 0.2)
      : theme.palette.primary.light};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: ${({ $percentage }) => `${100 - $percentage}%`};

    transition: right 200ms;

    background: ${({ theme, $variant }) =>
      $variant === ProgressBarVariants.Inverse
        ? theme.palette.info.main
        : theme.palette.primary.main};
    border-radius: ${({ theme }) => theme.spacing(4)};
  }
`;
